import type { ReactNode } from 'react'

/**
 * Default empty-gallery illustration: stacked photos icon, themed with currentColor.
 */
function TrayEmptyImagesIcon() {
  return (
    <svg viewBox="0 0 22 22" className="size-6" fill="none" aria-hidden="true">
      <path
        d="M17 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V5M21 12L19.704 10.704C19.252 10.2522 18.6391 9.99829 18 9.99829C17.3609 9.99829 16.748 10.2522 16.296 10.704L10 17M13 7C13 8.10457 12.1046 9 11 9C9.89543 9 9 8.10457 9 7C9 5.89543 9.89543 5 11 5C12.1046 5 13 5.89543 13 7ZM7 1H19C20.1046 1 21 1.89543 21 3V15C21 16.1046 20.1046 17 19 17H7C5.89543 17 5 16.1046 5 15V3C5 1.89543 5.89543 1 7 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

type TrayEmptyStateProps = {
  title: string
  /** Secondary hint under the title, e.g. "Try adjusting your filters…". Omitted when absent. */
  description?: string
  /** Replaces the default stacked-photos illustration. */
  icon?: ReactNode
}

export function TrayEmptyState({ title, description, icon }: TrayEmptyStateProps) {
  return (
    <div
      className="flex w-full shrink-0 flex-col items-center gap-6 py-6 text-center"
      role="status"
    >
      <div className="flex w-full flex-col items-center gap-4">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted text-foreground">
          {icon ?? <TrayEmptyImagesIcon />}
        </div>
        <div className="flex w-full max-w-[308px] flex-col gap-2">
          <p className="text-lg font-medium leading-7 tracking-[-0.09px] text-foreground">
            {title}
          </p>
          {description ? (
            <p className="text-sm font-normal leading-5 text-muted-foreground">{description}</p>
          ) : null}
        </div>
      </div>
    </div>
  )
}
